const prefix = 'SUBMISSIONS_FORM_ADMIN';

export const SAVE_SUBMISSION_FORM_ADMIN = `${prefix}/SAVE_SUBMISSION_FORM_ADMIN`;
export const SUBMIT_SUBMISSION_FORM = `${prefix}/SUBMIT_SUBMISSION_FORM`;
export const SET_SUBMISSION_ID = `${prefix}/SET_SUBMISSION_ID`;
export const SET_SORT_BY = `${prefix}/SET_SORT_BY`;
